import { render, staticRenderFns } from "./UnregisteredDevices.vue?vue&type=template&id=2c728fc4&"
import script from "./UnregisteredDevices.vue?vue&type=script&lang=js&"
export * from "./UnregisteredDevices.vue?vue&type=script&lang=js&"
import style0 from "./UnregisteredDevices.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports